export function serializeWithMetadata(obj) {
    var _a, _b;
    let result = `Type:${typeof obj}`;
    try {
        if (typeof obj === 'object') {
            result += `|Constructor:${obj === null || obj === void 0 ? void 0 : obj.constructor.name}`;
            if (obj instanceof Event) {
                result += `|EventType:${obj.type}`;
            }
            result += `|Value:${(_a = JSON.stringify(obj)) === null || _a === void 0 ? void 0 : _a.substr(0, 100)}`;
        }
        else if (typeof obj === 'function') {
            result += `|Name:${obj.name}`;
        }
        else {
            result += `|Value:${(_b = JSON.stringify(obj)) === null || _b === void 0 ? void 0 : _b.substr(0, 100)}`;
        }
    }
    catch (e) {
        result += '|Unable to serialize';
        if (e instanceof Error) {
            result += `: ${e.message.substr(0, 100)}`;
        }
    }
    return result;
}
//# sourceMappingURL=serialize-with-metadata.js.map